import $ from 'jquery'

export function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


document.addEventListener('DOMContentLoaded', function() {
  if(getCookie('banner_closed') == 'true'){
    console.log('banner_closed');
    $("#home-banner").hide();
  }
  else {
    $("#home-banner").show();
  }
});

$("body").on("click", ".home-banner-close", function (e) {
  e.stopImmediatePropagation();
  e.preventDefault();
  setCookie('banner_closed', 'true', 1); // Set cookie for 1 day
  $(this).closest("#home-banner").fadeOut();
});